import { isWeb } from "@memorang/helpers/platform";
import { Appbar, Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import { useDevice } from "../../useDevice";
import AppbarAction from "../AppbarAction";
import Box from "../Box";
import { CustomBreadcrumb } from "../CustomBreadcrumb";
import CommandbarContainer from "./CommandbarContainer";
import type { CustomAppBarProps } from "./types";

const RightContent = (
	props: Pick<
		CustomAppBarProps,
		| "hideCommandBar"
		| "renderRight"
		| "renderCustomCommandBar"
		| "handleTrackEvent"
	>,
) => {
	const { isMobile } = useDevice();

	if (props.renderRight) {
		return props.renderRight();
	}

	const handleTrackEvent =
		props.handleTrackEvent ??
		(() => {
			return;
		});

	const showCommandBar = !props.hideCommandBar && isWeb && !isMobile;

	return (
		<Box flexDirection="row" alignItems="center" gap={4}>
			{props.renderCustomCommandBar ? (
				props.renderCustomCommandBar()
			) : showCommandBar ? (
				<CommandbarContainer handleTrackEvent={handleTrackEvent} />
			) : null}
		</Box>
	);
};

export const CustomAppBar = (props: CustomAppBarProps) => {
	const { title, breadcrumbs } = props;

	const theme = useAppTheme();
	const { isMobile } = useDevice();

	const navigation =
		props.leftIconType !== "back" ? props.navigation : undefined;
	const showHamburgerMenu =
		props.leftIconType !== "back" &&
		isWeb &&
		isMobile &&
		!!navigation?.toggleDrawer;
	const showBreadcrumbs = !!breadcrumbs?.length && isWeb && !isMobile;

	return (
		<Box>
			<Appbar.Header
				theme={theme}
				mode="small"
				style={{
					backgroundColor: theme.colors.surface,
					paddingRight: 16,
					height: 64,
				}}
				elevated
			>
				{showHamburgerMenu && (
					<AppbarAction
						icon="menu"
						accessibilityRole="button"
						accessibilityLabel="Open menu"
						onPress={() => navigation?.toggleDrawer?.()}
					/>
				)}
				{props.leftIconType === "back" && (
					<Appbar.BackAction
						accessibilityRole="button"
						accessibilityLabel="Go back"
						onPress={props.onPressBack}
					/>
				)}
				<Appbar.Content
					title={
						showBreadcrumbs ? (
							<CustomBreadcrumb breadcrumbs={breadcrumbs} />
						) : typeof title === "string" ? (
							<Text
								numberOfLines={1}
								variant={isMobile ? "titleLarge" : "titleSmall"}
								style={{ fontWeight: "400" }}
							>
								{title}
							</Text>
						) : (
							title
						)
					}
				/>
				<RightContent {...props} />
			</Appbar.Header>
		</Box>
	);
};

export default CustomAppBar;
